<template>
  <!-- Welcome to Colloquium -->
    <div class="text-center" id="wtc">
      <cq-header id="life" headertext="TAKE YOUR LIFE TO THE NEXT LEVEL WITH COLLOQUIUM - THE GAIN LIVINAR"></cq-header>
      <cq-paratext class="noBtmSpace"> You Gain only when your actions speak louder than words. </cq-paratext>
      <cq-paratext> The Colloquium makes you <b>'LIVE PRODUCTIVITY'</b> and produce <b>'TANGIBLE RESULTS'</b> everyday as a <b>HABIT.</b> </cq-paratext>
      <h2> The Colloquium is NOT a Training Program or a Workshop. </h2>
      <div class="flaps__wrapper">
        <b-container>
          <div class="flaps__section" v-for="(flap,index) in flapsData" :key="index">
            <section-tabHead inverse>{{flap.title}}</section-tabHead>
            <div class="flaps__text">
              <p>{{flap.desc}}</p>
            </div>
          </div>
        </b-container>
      </div>
      <b-container class="bv-example-row icons">
      <!-- <b-img :src="images.icons" fluid alt="Icons Image" id="icons-img"></b-img> -->
        <b-row>
          <b-col cols="6" lg="3">
            <b-img :src="images.work" fluid alt="Work Image" id="work-img"></b-img><br>
            <cq-paratext> <b> WORK </b> <br> Hit your Targets <br> at Work  </cq-paratext>
          </b-col>

          <b-col cols="6" lg="3">
            <b-img :src="images.family" fluid alt="family Image" id="family-img"></b-img>
            <cq-paratext> <b> FAMILY </b> <br> Spend Quality Time <br> with Family  </cq-paratext>
          </b-col>

          <b-col cols="6" lg="3">
            <b-img :src="images.dream" fluid alt="dream Image" id="dream-img"></b-img>
            <cq-paratext> <b> DREAM </b> <br> Fulfill your Biggest <br> Dream  </cq-paratext>
          </b-col>

          <b-col cols="6" lg="3">
            <b-img :src="images.havetodo" fluid alt="havetodo Image" id="havetodo-img"></b-img>
            <cq-paratext> <b> HAVE TO DO </b> <br> Transform 'Have to Do <br> to Fun to Do'  </cq-paratext>
          </b-col>
        </b-row>
      </b-container>
      
    </div>
    <!-- End Welcome to Colloquium -->
</template>

<script>
import CQHeader from '../../components/ui/CQHeader.vue'
import CQPara from '../../components/ui/CQPara.vue'
import TabHead from "../Shared/TabHead";
// import CQHeadings from '../../components/ui/CQHeadings.vue'

// Import Images
import welcome from '../../assets/image/home/welcome.png'
import icons from '../../assets/image/home/icons.png'
import work from '../../assets/image/home/work.png'
import family from '../../assets/image/home/family.png'
import dream from '../../assets/image/home/dream.png'
import havetodo from '../../assets/image/home/havetodo.png'


export default {
    components: {
        'cq-header' : CQHeader,
        'cq-paratext' : CQPara,
        "section-tabHead": TabHead
        // 'cq-headings' : CQHeadings,
    },
    data() {
        return {
          flapsData:[
            {
              title:"THE COLLOQUIUM IS PERSONALIZED",
              desc:"It is the world's ONLY Customized Eco-system that will give you a Personal implementation Consultant who hand-holds you almost on a daily basis over 90 days to produce Tangible Results in a time-bound manner."
            },
            {
              title:"PURPOSE-DRIVEN ",
              desc:"Manan Vasa’s ‘Make It Happen Framework©’ will make you first find your Purpose and create ‘Your Moment to Live for’ so that you to stop being a Spectator and start being the Player."
            },
            {
              title:"PRACTICAL",
              desc:"To fulfill that Purpose you will then define your Goals across four critical areas of your life - Work, Family, Personal Dream & Have-to-do."
            },
            {
              title:"PLANNED",
              desc:"Manan Vasa will customise his set of his Proprietary Tools for you to make a comprehensive, fool-proof, implementation plan for each of your Goals."
            },
            {
              title:"PERFORMANCE-ORIENTED",
              desc:"To make your Goals a reality, a dedicated Consultant will hand-hold you to master ‘Million Dollar Habits’ over the next 90 days so that you can achieve your Goals week after week."
            },
            {
              title:"IMPLEMENTATION  SYSTEM",
              desc:"It is a system for LIVING your PURPOSE and Maximising Your GAINS in every area of your life as a HABIT."
            }
          ],
          images: { 
              welcome,
              icons,
              work,
              family,
              dream,
              havetodo
          }
        }
    }
}
</script>

<style scoped>    
#wtc >>> #resize{
  padding: 20px;
}

#wtc >>> .noBtmSpace{
  margin-bottom: 0 !important;
}

.flaps__wrapper{
  margin:34px 0 60px 0;
}

.flaps__text{
  margin: 34px 0;
}

.flaps__text p{
  text-align: center;
  font-family: "Seravek-Light";
  color: var(--text-color);
  font-size: 20px;
  margin-bottom: 0;
}

/* Mobile View */
@media only screen and (max-width: 992px){
    #wtc >>> #icons{
        padding: 0 10px;
    }

    #wtc >>> #welcome{
      padding: 5%;
    }

    #wtc >>> .icons img{
      max-width: 80%;
    }
}

/* Desktop View */
@media only screen and (min-width: 992px){
  #wtc >>> .icons{
    max-width: 60% !important;
  }

  #wtc  >>> .icons img{
    padding-bottom: 5%;
  }

  #wtc >>> #resize{
    padding: 50px 140px;
  }


  #wtc >>> .icons p{
    /* font-family: 'Seravek-Medium'; */
    font-size: 16px;
    color: #212529;
  }
}
</style>